<template>
  <section
    class="RunWaitlistButtonView"
  >
    <FormButton
      data-testid="waitlistButton"
      @click="!currentSubRequest ? handleJoinWaitlistClick() : handleLeaveWaitlistClick()"
    >
      <span v-if="!currentSubRequest">Join the waitlist</span>
      <span v-else>Leave the waitlist</span>
    </FormButton>
  </section>
</template>

<script lang="ts" setup>
import FormButton from "@/components/FormButton.vue";
import { supabaseClient } from "@/lib/database/supabase";
import useAuthStore from "@/stores/useAuthStore";
import { RunSummary, SubRequestSummary } from "@shared/lib/database/query.types";
import { storeToRefs } from "pinia";
import { computed, toRefs } from "vue";

const props = defineProps<{
  run: RunSummary & {
    sub_requests: Array<SubRequestSummary>,
  },
}>();

const {
  run,
} = toRefs(props);

const {
  currentPlayer,
} = storeToRefs(useAuthStore());

const currentSubRequest = computed(() => {
  return run.value?.sub_requests.find((subRequest) => subRequest.player_id === currentPlayer.value?.id);
});

// TODO: DRY
function removeSubRequest (subRequest: Partial<SubRequestSummary>) {
  if (!run.value) return;
  const index = run.value.sub_requests.findIndex((_subRequest) => _subRequest.id === subRequest.id);

  if (index !== -1) run.value.sub_requests.splice(index, 1);
}

async function handleJoinWaitlistClick () {
  if (!run.value || !currentPlayer.value) return;

  const {
    data: subRequest,
    error,
  } = await supabaseClient.from("sub_requests").insert({
    run_id: run.value.id,
    player_id: currentPlayer.value.id,
    probability: 1,
  })
    .select()
    .maybeSingle();

  if (error) {
    alert(error.message);
  } else if (subRequest) {
    run.value.sub_requests.push({
      id: subRequest.id,
      run_id: subRequest.run_id,
      player_id: subRequest.player_id,
      accepted_at: subRequest.accepted_at,
    });
  }
}

async function handleLeaveWaitlistClick () {
  if (!run.value || !currentSubRequest.value) return;

  const {
    data: subRequest,
    error,
  } = await supabaseClient.from("sub_requests")
    .delete()
    .eq("id", currentSubRequest.value.id)
    .select()
    .maybeSingle();

  if (error) {
    alert(error.message);
  } else if (subRequest) {
    removeSubRequest(subRequest);
  }
}
</script>
